import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface LiveTvIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const LiveTvIcon = observer('LiveTvIcon', ({ className, onClick }: LiveTvIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            height='24'
            onClick={onClick}
            viewBox='0 0 24 24'
            width='24'
            fill='#131419'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fill='fill'
                fillRule='evenodd'
                d='M21.447 5.08c-.369-.354-.794-.531-1.276-.531H3.83c-.483 0-.909.177-1.277.532A1.732 1.732 0 0 0 2 6.379v10.893c0 .483.185.901.554 1.256.368.354.794.532 1.276.532h16.34c.483 0 .908-.178 1.277-.532.37-.355.553-.773.553-1.256V6.38c0-.51-.184-.944-.553-1.298Zm-5.83 6.745-6.34-3.66v7.278l6.34-3.617Z'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
